export default __webpack_public_path__ + "assets/models/b935a9c97a9bb64ea06c58af7bfb454f.glb";